import { action, thunk } from 'easy-peasy';
import _e from 'common/localeUtil';
import * as templateService from './services';
import { convertTestimonialsMessagesToHTML, loadTemplate } from '../utils';
import { DEFAULT_EBOOK_URL, DEFAULT_TH_EBOOK_URL } from '../constants';

const templateModel = {
	template: '',
	profile: {
		jwt: '',
		userId: '',
		email: '',
		firstName: '',
		lastName: '',
		profileImageUrl: '',
	},
	template_metas: [],
	testimonials: [],
	adviserData: {},
	subdomain: '',
	siteSettings: {},
	contactForm: {},
	testimonialsSettings: {},
	seo: {},
	statusData: {},
	extraProfile: {},
	ebook: {},
	otherSettings: {},
	changeSubdomain: thunk(async (actions, payload) => {
		// call our service
		const responseData = await templateService.changeSubdomain(payload);
		// then dispatch an action to update state
		if (responseData?.success) {
			actions.setSubdomain(responseData?.subdomain);
		}
		return responseData;
	}),
	saveOtherSettings: thunk(async (actions, payload) => {
		// call our service
		const responseData = await templateService.saveOtherSettings(payload);
		// then dispatch an action to update state
		if (responseData?.success) {
			actions.setOtherSettings(responseData?.other_settings);
		}
		return responseData;
	}),
	loadTemplate: thunk(async (actions) => {
		const response = await loadTemplate();
		const responseData = response.data;
		console.log('templateModel loadTemplate', responseData);
		const country = responseData?.adviser_data?.country;
		actions.setSiteSettings(responseData?.site_settings);
		actions.setSubdomain(responseData?.subdomain);
		actions.setTestimonials(responseData?.testimonials);
		actions.setTestimonialsSettings(responseData?.testimonials_settings);
		const defaultEbookURL = country === 'TH' ? DEFAULT_TH_EBOOK_URL : DEFAULT_EBOOK_URL;
		window.adviserData = responseData?.adviser_data || {};
		const { full_name, profile_picture, email } = window.adviserData;
		// Set default seo values
		const seo = responseData?.seo || {};
		const {
			seo_title = _e('user_financial_planning', { userName: full_name }),
			seo_description = _e('precise_desc_awesome_page'),
			seo_focus_keyword = _e('financial_planner'),
			seo_image_url = profile_picture,
			seo_favicon_url,
		} = seo;
		actions.setSEO({
			...seo,
			seo_title,
			seo_description,
			seo_focus_keyword,
			seo_image_url,
			seo_favicon_url,
		});
		const extraProfile = responseData?.extra_profile || {};
		actions.setExtraProfile(extraProfile);

		const ebook = responseData?.ebook || {};
		actions.setEbook(ebook);
		const { final_s3_url: finalS3Url = defaultEbookURL } = ebook;
		localStorage.setItem('GM_EBOOK_FINAL_URL', finalS3Url);
		// console.log('GM_EBOOK_FINAL_URL', finalS3Url);

		const contactForm = responseData?.contact_form || {};
		const { receiving_email = email } = contactForm;
		actions.setContactForm({
			...contactForm,
			receiving_email,
		});

		window.GM_STATUS_DATA = {
			website_status: responseData?.website_status,
			report_status: responseData?.report_status,
			ebookintro_status: responseData?.ebookintro_status,
		};
		actions.setStatusData(window.GM_STATUS_DATA);
		//

		window.adviserSubdomain = responseData?.subdomain;
		window.testimonials = responseData?.testimonials;
		// Convert testimonials messages to HTML
		window.testimonialsMessagesHTML = convertTestimonialsMessagesToHTML(window.testimonials);
		actions.setAdviserData(window.adviserData);

		actions.setOtherSettings(responseData?.other_settings);
	}),
	saveSEOImageUrl: thunk(async (actions, seoImageUrl, { getState }) => {
		const saveRes = await templateService.saveAllSettings({
			seo_image_url: seoImageUrl,
		});
		const { seo } = getState();
		actions.setSEO({
			...seo,
			seo_image_url: seoImageUrl,
		});
		return saveRes;
	}),
	saveFaviconUrl: thunk(async (actions, saveFaviconUrl, { getState }) => {
		const saveRes = await templateService.saveAllSettings({
			seo_favicon_url: saveFaviconUrl,
		});
		const { seo } = getState();
		actions.setSEO({
			...seo,
			seo_favicon_url: saveFaviconUrl,
		});
		return saveRes;
	}),
	setTestimonials: action((state, testimonials) => {
		state.testimonials = testimonials;
	}),
	setTestimonialsSettings: action((state, testimonialsSettings) => {
		state.testimonialsSettings = testimonialsSettings;
	}),
	setOtherSettings: action((state, otherSettings) => {
		state.otherSettings = otherSettings;
	}),
	setSubdomain: action((state, subdomain) => {
		state.subdomain = subdomain;
	}),
	setSEO: action((state, seo) => {
		state.seo = seo;
	}),
	setSiteSettings: action((state, siteSettings) => {
		state.siteSettings = siteSettings;
	}),
	setContactForm: action((state, contactForm) => {
		state.contactForm = contactForm;
	}),
	setTemplate: action((state, template) => {
		state.template = template;
	}),
	setProfileDetail: action(
		(state, { jwt, userId, email, firstName, lastName, profileImageUrl }) => {
			state.profile = {
				jwt,
				userId,
				email,
				firstName,
				lastName,
				profileImageUrl,
			};
		},
	),
	setTemplateMetas: action((state, template_metas) => {
		state.template_metas = template_metas;
	}),
	setAdviserData: action((state, adviserData) => {
		state.adviserData = adviserData;
	}),
	setStatusData: action((state, statusData) => {
		state.statusData = statusData;
	}),
	setExtraProfile: action((state, extraProfile) => {
		state.extraProfile = extraProfile;
	}),
	setEbook: action((state, ebook) => {
		state.ebook = ebook;
	}),
	setProfileImage: action((state, profileImageUrl) => {
		state.profile.profileImageUrl = profileImageUrl;
	}),
	saveAllSettings: thunk(async (actions, payload) => {
		const saveRes = await templateService.saveAllSettings(payload);
		const responseStatus = saveRes?.status;
		if (responseStatus === 200) {
			actions.setSubdomain(payload.subdomain);
			actions.setExtraProfile(payload.extra_profile);
			actions.setSEO(payload.seo);
			actions.setContactForm(payload.contact_form);
		}
		return saveRes;
	}),
};

export default templateModel;
